import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'pec-loading',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
  host: {
    '[class.is-fullscreen]': 'fullscreen',
    '[class.is-inline]': '!fullscreen',
  },
})
export class LoadingComponent {
  @Input() fullscreen = false;
  @Input() message = '';
  @Input() blur = true;
  @Input() diameter = 40;
}
